module.exports = __webpack_public_path__ + "img/cvv.8bdc1b0.png";